import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ShieldCheck, ShieldX, Award } from "lucide-react";
import { api } from "@/lib/api";
import { Seo } from "@/components/Seo";

export default function VerifyCertificate() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/certificates/verify/${id}`).then(({ data }) => setData(data)).catch(() => setData({ found: false })).finally(() => setLoading(false));
  }, [id]);

  return (
    <div className="min-h-screen bg-[#080808] flex flex-col items-center justify-center px-5 py-16" data-testid="verify-certificate-page">
      <Seo title="Verify Certificate · ERRĀH" description="Verify an ERRĀH Certified Applicator certificate" />
      <Link to="/" className="flex items-center gap-2 mb-8"><img src="/errah-logo.png" alt="ERRĀH" className="h-9" /><span className="font-serif tracking-[0.25em]">ERRĀH</span></Link>

      {loading ? <p className="text-gray-500">Verifying…</p> : !data?.found ? (
        <div className="hair-border bg-red-500/10 border-red-500/40 p-8 text-center max-w-md w-full" data-testid="verify-notfound">
          <ShieldX className="mx-auto text-red-400" size={44} />
          <p className="font-display text-xl mt-3">Certificate Not Found</p>
          <p className="text-sm text-gray-400 mt-1">No ERRĀH certificate matches <span className="font-mono">{id}</span>.</p>
        </div>
      ) : (
        <div className={`hair-border p-8 text-center max-w-md w-full ${data.valid ? "bg-emerald-500/10 border-emerald-500/40" : "bg-yellow-500/10 border-yellow-500/40"}`} data-testid="verify-result">
          {data.valid ? <ShieldCheck className="mx-auto text-emerald-400" size={44} /> : <ShieldX className="mx-auto text-yellow-400" size={44} />}
          <p className="font-display text-2xl mt-3">{data.valid ? "Valid Certificate" : `Certificate ${data.status}`}</p>
          <div className="mt-5 flex items-center justify-center gap-2 text-[#C9A45C]"><Award size={18} /><span className="font-display text-lg">{data.service_name}</span></div>
          <div className="mt-5 space-y-2 text-sm text-left inline-block">
            <p><span className="text-gray-500">Applicator:</span> {data.applicator_name} ({data.applicator_code})</p>
            <p><span className="text-gray-500">Certificate ID:</span> <span className="font-mono text-[#E4C987]">{data.certificate_id}</span></p>
            <p><span className="text-gray-500">Issued:</span> {(data.issued_at || "").slice(0, 10)}</p>
            <p><span className="text-gray-500">Valid until:</span> {data.valid_until ? data.valid_until.slice(0, 10) : "No expiry"}</p>
          </div>
        </div>
      )}
      <p className="text-[11px] text-gray-600 mt-8">ERRĀH Certified Applicator Network · www.theerrah.com</p>
    </div>
  );
}
